import React, { useCallback } from 'react';
import { Col, Row, Table } from 'antd';
import { useParams } from 'react-router-dom';
import { PageHeader } from '../../../components/layout/PageHeader';
import { useGetClientAndInboxes } from '../../../lib/hooks';
import { Inbox } from '../../../types';
import { getClientOverviewTableColumns } from './ClientOverviewTable';
import { ErrorText } from '../../../components/text/ErrorText';

const ClientOverview = () => {
  const { clientName } = useParams<{ clientName: string }>();

  const { client, inboxes, loading, error } = useGetClientAndInboxes(clientName);

  const onClickUrl = useCallback(
    (record: Inbox) => {
      return `/inbox/${clientName}/${record.document_class}/overview`;
    },
    [clientName]
  );

  return (
    <>
      <PageHeader
        container="client"
        header={client ? client.io_customer_name : null}
        description={client ? "These are the inboxes for the client '" + client.io_customer_name + "'" : null}
      />
      <Row className="my-3" style={{ height: 40 }}></Row>
      <Row>
        <Col span={24}>
          {error ? (
            <ErrorText>Something went wrong, we could not find the inboxes you were looking for.</ErrorText>
          ) : (
            <Table
              className="ant-table-toolbox"
              columns={getClientOverviewTableColumns(onClickUrl)}
              rowKey={inbox => inbox.document_class}
              dataSource={inboxes}
              loading={loading}
              pagination={false}
            />
          )}
        </Col>
      </Row>
    </>
  );
};

export default ClientOverview;
